(function () {
  'use strict';

  var sliders = document.querySelectorAll('[data-bhs]');
  if (!sliders.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sliders.forEach(function (root) {
    var track = root.querySelector('[data-bhs-track]');
    var prev  = root.querySelector('[data-bhs-prev]');
    var next  = root.querySelector('[data-bhs-next]');
    var dotsHost = root.querySelector('[data-bhs-dots]');
    var slides = Array.from(root.querySelectorAll('[data-bhs-slide]'));
    if (!track || slides.length === 0) return;

    var autoplayMs = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var isInfinite = root.getAttribute('data-infinite') !== 'false';
    var pauseHover = root.getAttribute('data-pause-hover') !== 'false';
    var pauseOff   = root.getAttribute('data-pause-offscreen') !== 'false';

    if (prefersReducedMotion) autoplayMs = 0;

    var currentIndex = 0;
    var autoplayTimer = null;
    var isHovered = false;
    var isOffscreen = false;
    var isFocused = false;

    if (dotsHost) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bhs__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', function () { goToIndex(i); });
        dotsHost.appendChild(dot);
      });
    }

    function getSlideWidth() {
      return track.clientWidth;
    }

    function goToIndex(index) {
      if (index < 0) index = isInfinite ? slides.length - 1 : 0;
      if (index >= slides.length) index = isInfinite ? 0 : slides.length - 1;
      var behavior = prefersReducedMotion ? 'auto' : 'smooth';
      track.scrollTo({ left: index * getSlideWidth(), behavior: behavior });
    }

    function goNext() { goToIndex(currentIndex + 1); }
    function goPrev() { goToIndex(currentIndex - 1); }

    var syncTimer = null;
    var scrollEndTimer = null;
    var mobileMQ = window.matchMedia('(max-width: 749px)');

    function syncTrackHeight() {
      var isMobile = mobileMQ.matches;

      if (!isMobile) {
        // Desktop: clear inline var + clear track inline height so CSS fixed height wins
        root.style.removeProperty('--bhs-active-slide-h');
        if (track) track.style.removeProperty('height');
        return;
      }

      var activeSlide = slides[currentIndex];
      if (!activeSlide) return;

      // scrollHeight reflects content even if the element was visually constrained
      var h = activeSlide.scrollHeight;

      if (h > 0) {
        root.style.setProperty('--bhs-active-slide-h', h + 'px');
        // Belt-and-suspenders: also set on track in case external CSS specificity fights the var
        if (track) track.style.height = h + 'px';
      }
    }

    function syncState() {
      var idx = Math.round(track.scrollLeft / getSlideWidth());
      var indexChanged = idx !== currentIndex;
      currentIndex = idx;

      if (indexChanged) {
        if (dotsHost) {
          Array.from(dotsHost.children).forEach(function (dot, i) {
            if (i === currentIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }

        if (!isInfinite) {
          if (prev) prev.disabled = currentIndex === 0;
          if (next) next.disabled = currentIndex === slides.length - 1;
        }

        manageVideos();
      }
      /* NOTE: height is NOT changed here. Resizing the scroll container while a
         swipe/momentum scroll is in progress freezes it half-way on iOS.
         Height is updated only on scroll-end (debounced below). */
    }

    track.addEventListener('scroll', function () {
      if (syncTimer) cancelAnimationFrame(syncTimer);
      syncTimer = requestAnimationFrame(syncState);

      // Resize the track to the landed slide ONLY after scrolling settles.
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(syncTrackHeight, 120);
    });

    if (next) next.addEventListener('click', goNext);
    if (prev) prev.addEventListener('click', goPrev);

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goNext(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goPrev(); }
    });

    function startAutoplay() {
      if (!autoplayMs) return;
      if (isHovered || isOffscreen || isFocused) return;
      stopAutoplay();
      autoplayTimer = setInterval(goNext, autoplayMs);
    }
    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (pauseHover) {
      root.addEventListener('mouseenter', function () { isHovered = true; stopAutoplay(); });
      root.addEventListener('mouseleave', function () { isHovered = false; startAutoplay(); });
    }
    root.addEventListener('focusin',  function () { isFocused = true;  stopAutoplay(); });
    root.addEventListener('focusout', function () { isFocused = false; startAutoplay(); });
    root.addEventListener('touchstart', function () { stopAutoplay(); }, { passive: true });

    if (pauseOff && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isOffscreen = !entry.isIntersecting;
          if (isOffscreen) {
            stopAutoplay();
            pauseAllVideos();
          } else {
            startAutoplay();
            manageVideos();
          }
        });
      }, { threshold: 0.1 });
      io.observe(root);
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        track.scrollTo({ left: currentIndex * getSlideWidth(), behavior: 'auto' });
        syncTrackHeight();
      }, 150);
    });

    function manageVideos() {
      slides.forEach(function (slide, i) {
        var native   = slide.querySelector('video.bhs__video');
        var iframe   = slide.querySelector('iframe.bhs__video-iframe');
        var provider = slide.getAttribute('data-video-provider');

        if (i === currentIndex && !prefersReducedMotion) {
          if (native && native.paused) {
            var p = native.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
          if (iframe) postIframeCommand(iframe, provider, 'play');
        } else {
          if (native && !native.paused) {
            try { native.pause(); } catch (e) {}
          }
          if (iframe) postIframeCommand(iframe, provider, 'pause');
        }
      });
    }

    function pauseAllVideos() {
      slides.forEach(function (slide) {
        var native   = slide.querySelector('video.bhs__video');
        var iframe   = slide.querySelector('iframe.bhs__video-iframe');
        var provider = slide.getAttribute('data-video-provider');
        if (native && !native.paused) {
          try { native.pause(); } catch (e) {}
        }
        if (iframe) postIframeCommand(iframe, provider, 'pause');
      });
    }

    function postIframeCommand(iframe, provider, command) {
      if (!iframe || !iframe.contentWindow) return;
      try {
        if (provider === 'youtube') {
          var func = command === 'play' ? 'playVideo' : 'pauseVideo';
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*');
        } else if (provider === 'vimeo') {
          var method = command === 'play' ? 'play' : 'pause';
          iframe.contentWindow.postMessage(JSON.stringify({ method: method }), '*');
        }
      } catch (e) {
        /* postMessage failures aren't actionable */
      }
    }

    if (!isInfinite && prev) prev.disabled = true;
    if (!isInfinite && slides.length === 1 && next) next.disabled = true;

    if (prefersReducedMotion) pauseAllVideos();
    startAutoplay();
    manageVideos();

    // Initial height sync deferred to next frame so layout is fully resolved
    requestAnimationFrame(syncTrackHeight);

    // Re-measure when crossing the mobile/desktop breakpoint
    if (mobileMQ.addEventListener) {
      mobileMQ.addEventListener('change', syncTrackHeight);
    } else if (mobileMQ.addListener) {
      mobileMQ.addListener(syncTrackHeight);
    }

    // Re-measure after webfonts apply (heading/text height can shift)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncTrackHeight);
    }

    // Re-measure after each media image decodes (aspect-ratio settles)
    var slideImages = root.querySelectorAll('.bhs__media img');
    slideImages.forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', syncTrackHeight, { once: true });
    });
  });
})();